import React from 'react';
import { Leaf, Heart, Zap, Home, Award, BookOpen, FlaskConical, Smile, Check, Star } from 'lucide-react';
import { Section, OrganicDivider } from './ui';
export const MethodRaiz = () => {
  const methods = [{
    letter: 'R',
    title: 'Regenera',
    desc: 'Apoya el equilibrio natural del cuerpo.',
    icon: <Heart className="text-herbal" size={24} data-id="element-207" />
  }, {
    letter: 'A',
    title: 'Alivia',
    desc: 'Preparaciones naturales para molestias comunes.',
    icon: <Leaf className="text-herbal" size={24} data-id="element-208" />
  }, {
    letter: 'I',
    title: 'Impulsa',
    desc: 'Más energía y bienestar diario.',
    icon: <Zap className="text-herbal" size={24} data-id="element-209" />
  }, {
    letter: 'Z',
    title: 'Zona Natural',
    desc: 'Convierte tu hogar en un espacio de bienestar herbal.',
    icon: <Home className="text-herbal" size={24} data-id="element-210" />
  }];
  return <>
      <OrganicDivider type="wave" color="fill-beige" data-id="element-211" />
      <Section bg="cream" className="pt-8" data-id="element-212">
        <div className="max-w-4xl mx-auto mb-12 rounded-[24px] overflow-hidden shadow-xl border-4 border-white" data-id="element-213">
          <img src="https://cdn.magicpatterns.com/uploads/6TsfU44XmqJwdisH6J7qoT/ChatGPT_Image_7_may_2026,_11_05_23_a.m.png" alt="El Gran Manual de Preparaciones Medicinales Naturales" className="w-full h-auto object-cover" data-id="element-214" />
        </div>

        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-215">
          <span className="inline-block py-1 px-3 rounded-full bg-gold/20 text-petroleum text-sm font-bold tracking-widest mb-4" data-id="element-216">
            MÉTODO EXCLUSIVO
          </span>
          <h2 className="text-4xl md:text-5xl font-heading font-bold text-petroleum mb-6" data-id="element-217">
            MÉTODO R.A.I.Z™
          </h2>
          <div className="inline-flex items-center gap-2 bg-herbal/10 text-herbalDark px-4 py-2 rounded-full font-medium" data-id="element-218">
            <Award size={18} data-id="element-219" />
            Basado en medicina herbal ancestral y bienestar natural moderno.
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-220">
          {methods.map((item, i) => <div key={i} className="bg-white p-8 rounded-[24px] shadow-sm border border-gray-100 relative overflow-hidden group hover:shadow-md transition-all" data-id="element-221">
              <div className="absolute -right-4 -top-4 text-9xl font-heading font-bold text-gray-50 opacity-50 group-hover:scale-110 transition-transform" data-id="element-222">
                {item.letter}
              </div>
              <div className="relative z-10" data-id="element-223">
                <div className="w-12 h-12 bg-herbal/10 rounded-2xl flex items-center justify-center mb-6" data-id="element-224">
                  {item.icon}
                </div>
                <h3 className="text-2xl font-heading font-bold text-petroleum mb-3 flex items-center gap-2" data-id="element-225">
                  <span className="text-herbal" data-id="element-226">{item.letter}</span> —{' '}
                  {item.title}
                </h3>
                <p className="text-gray-600" data-id="element-227">{item.desc}</p>
              </div>
            </div>)}
        </div>
      </Section>
    </>;
};
export const Authority = () => {
  const badges = [{
    icon: <Leaf size={20} data-id="element-228" />,
    text: 'Ingredientes naturales accesibles'
  }, {
    icon: <BookOpen size={20} data-id="element-229" />,
    text: 'Más de 970 preparaciones organizadas'
  }, {
    icon: <FlaskConical size={20} data-id="element-230" />,
    text: 'Inspirado en tradición herbal'
  }, {
    icon: <Smile size={20} data-id="element-231" />,
    text: 'Fácil incluso para principiantes'
  }];
  return <Section bg="dark" className="text-cream" data-id="element-232">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-14 items-center" data-id="element-233">
        {/* Image */}
        <div className="relative" data-id="element-234">
          <div className="absolute -inset-2 bg-gradient-to-br from-gold/30 via-herbal/20 to-gold/30 rounded-[28px] blur-xl opacity-60" data-id="element-235"></div>
          <div className="relative rounded-[24px] overflow-hidden shadow-2xl border-2 border-gold/40" data-id="element-236">
            <img src="https://cdn.magicpatterns.com/uploads/ibkiQYZLGkDXDb3jQrvyJh/ChatGPT_Image_7_may_2026,_12_40_38_p.m.png" alt="Conocimientos ancestrales transformados en bienestar" className="w-full h-auto object-cover" data-id="element-237" />
          </div>
        </div>

        {/* Content */}
        <div data-id="element-238">
          <div className="inline-flex items-center gap-2 bg-gold/10 border border-gold/30 text-gold px-4 py-1.5 rounded-full text-xs font-bold tracking-widest mb-5" data-id="element-239">
            <Award size={14} data-id="element-240" />
            AUTORIDAD ANCESTRAL
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-gold mb-6 leading-tight" data-id="element-241">
            Inspirado en conocimientos herbales utilizados durante{' '}
            <span className="italic" data-id="element-242">generaciones</span>.
          </h2>
          <p className="text-lg text-gray-300 leading-relaxed mb-8" data-id="element-243">
            El manual reúne recetas tradicionales, preparaciones herbales y
            combinaciones naturales utilizadas desde hace décadas para apoyar el
            bienestar físico y emocional.
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3" data-id="element-244">
            {badges.map((badge, i) => <div key={i} className="bg-white/5 border border-white/10 backdrop-blur-sm p-4 rounded-2xl flex items-center gap-3 hover:bg-white/10 hover:border-gold/30 transition-all" data-id="element-245">
                <div className="text-gold bg-gold/10 p-2 rounded-xl shrink-0" data-id="element-246">
                  {badge.icon}
                </div>
                <p className="font-medium text-sm text-gray-100" data-id="element-247">
                  {badge.text}
                </p>
              </div>)}
          </div>
        </div>
      </div>
    </Section>;
};
export const Testimonials = () => {
  const testimonials = [{
    name: 'María',
    age: 52,
    location: 'Bogotá',
    text: 'Vivía cansada y llena de dolores. Empecé a preparar algunas recetas y poco a poco me sentí con más energía y tranquilidad.',
    photo: 'https://images.unsplash.com/photo-1607746882042-944635dfe10e?q=80&w=400&auto=format&fit=crop&crop=faces'
  }, {
    name: 'Luciana',
    age: 47,
    location: 'Medellín',
    text: 'Lo que más me gustó es que todo es fácil y natural. Hoy me siento mucho más tranquila y conectada conmigo.',
    photo: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?q=80&w=400&auto=format&fit=crop&crop=faces'
  }, {
    name: 'Carmen',
    age: 61,
    location: 'Ciudad de México',
    text: 'Pensé que sería complicado, pero las recetas son sencillas. Ahora tengo una rutina natural que me hace sentir mejor.',
    photo: 'https://images.unsplash.com/photo-1559963110-71b394e7494d?q=80&w=400&auto=format&fit=crop&crop=faces'
  }];
  return <Section bg="beige" data-id="element-248">
      <div className="text-center max-w-2xl mx-auto mb-12" data-id="element-249">
        <div className="inline-flex items-center gap-2 bg-herbal/10 text-herbalDark px-4 py-1.5 rounded-full text-xs font-bold tracking-widest mb-4" data-id="element-250">
          ⭐ TESTIMONIOS REALES
        </div>
        <h2 className="text-3xl md:text-4xl font-heading font-bold text-petroleum" data-id="element-251">
          Lo que dicen quienes ya comenzaron su{' '}
          <span className="italic text-herbalDark" data-id="element-252">transformación natural</span>
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12" data-id="element-253">
        {testimonials.map((t, i) => <div key={i} className="bg-white p-8 rounded-[24px] shadow-md border border-gray-100 relative hover:shadow-xl hover:-translate-y-1 transition-all duration-300" data-id="element-254">
            {/* Quote mark decoration */}
            <div className="absolute -top-4 -left-2 text-gold/30 text-7xl font-heading font-bold leading-none select-none" data-id="element-255">
              "
            </div>

            <div className="text-gold mb-4 flex gap-1 relative" data-id="element-256">
              {[...Array(5)].map((_, j) => <Star key={j} size={18} fill="currentColor" data-id="element-257" />)}
            </div>
            <p className="text-gray-700 italic mb-6 text-lg leading-relaxed relative" data-id="element-258">
              {t.text}
            </p>
            <div className="flex items-center gap-3 pt-4 border-t border-gray-100" data-id="element-259">
              <div className="relative shrink-0" data-id="element-260">
                <div className="absolute -inset-0.5 bg-gradient-to-br from-herbal to-gold rounded-full" data-id="element-261"></div>
                <img src={t.photo} alt={t.name} className="relative w-14 h-14 rounded-full object-cover border-2 border-white" data-id="element-262" />
              </div>
              <div data-id="element-263">
                <p className="font-bold text-petroleum flex items-center gap-1.5" data-id="element-264">
                  {t.name}
                  <span className="inline-flex items-center text-[10px] bg-herbal/10 text-herbalDark px-1.5 py-0.5 rounded-full font-bold" data-id="element-265">
                    ✓ Verificado
                  </span>
                </p>
                <p className="text-sm text-gray-500" data-id="element-266">
                  {t.age} años · {t.location}
                </p>
              </div>
            </div>
          </div>)}
      </div>

      <div className="bg-petroleum text-white p-4 rounded-2xl text-center font-medium shadow-lg flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4" data-id="element-267">
        <span data-id="element-268">+27.000 personas ya comenzaron su transformación natural</span>
        <span className="hidden sm:inline text-gold" data-id="element-269">•</span>
        <span className="text-gold" data-id="element-270">97% recomienda el manual</span>
      </div>
    </Section>;
};
export const Benefits = () => {
  const benefits = [{
    icon: '🌿',
    text: 'Más bienestar diario'
  }, {
    icon: '💚',
    text: 'Menos sensación de inflamación'
  }, {
    icon: '😴',
    text: 'Mejor descanso'
  }, {
    icon: '⚡',
    text: 'Más energía natural'
  }, {
    icon: '🧘',
    text: 'Menos estrés emocional'
  }, {
    icon: '🍃',
    text: 'Ingredientes fáciles de conseguir'
  }, {
    icon: '🏡',
    text: 'Bienestar desde casa'
  }, {
    icon: '📚',
    text: 'Acceso de por vida'
  }, {
    icon: '✨',
    text: 'Sensación de equilibrio natural'
  }];
  return <>
      <OrganicDivider type="wave" color="fill-beige" data-id="element-271" />
      <Section bg="cream" className="pt-8" data-id="element-272">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center" data-id="element-273">
          {/* Left — Image */}
          <div className="relative order-2 lg:order-1" data-id="element-274">
            <div className="absolute -inset-3 bg-gradient-to-br from-herbal/30 via-gold/20 to-herbal/30 rounded-[28px] blur-2xl opacity-70" data-id="element-275"></div>
            <div className="relative rounded-[24px] overflow-hidden shadow-2xl border-4 border-white" data-id="element-276">
              <img src="https://cdn.magicpatterns.com/uploads/bHYms9Eodkkh7BpmTVWKyK/ChatGPT_Image_7_may_2026,_12_43_20_p.m.png" alt="Sabiduría ancestral para tu salud y la de tu familia" className="w-full h-auto object-cover" data-id="element-277" />
            </div>
            {/* Floating leaf accents */}
            <Leaf className="absolute -top-4 -right-4 text-herbal/30 w-16 h-16 rotate-45 hidden md:block" data-id="element-278" />
            <Leaf className="absolute -bottom-4 -left-4 text-gold/30 w-12 h-12 -rotate-12 hidden md:block" data-id="element-279" />
          </div>

          {/* Right — Content */}
          <div className="order-1 lg:order-2" data-id="element-280">
            <div className="inline-flex items-center gap-2 bg-herbal/10 text-herbalDark px-4 py-1.5 rounded-full text-xs font-bold tracking-widest mb-5" data-id="element-281">
              <Leaf size={14} data-id="element-282" />
              TU NUEVA REALIDAD
            </div>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-petroleum mb-4 leading-tight" data-id="element-283">
              Lo que cambia cuando comienzas a usar el{' '}
              <span className="italic text-herbalDark" data-id="element-284">Manual Herbal</span>:
            </h2>
            <p className="text-lg text-gray-600 mb-8 leading-relaxed" data-id="element-285">
              No es solo bienestar para ti — es la tranquilidad de cuidar a
              quienes amas con el poder de la naturaleza.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3" data-id="element-286">
              {benefits.map((b, i) => <div key={i} className="bg-white p-3 rounded-xl border border-gray-100 flex items-center gap-3 shadow-sm hover:border-herbal/40 hover:shadow-md transition-all" data-id="element-287">
                  <span className="text-xl shrink-0" data-id="element-288">{b.icon}</span>
                  <span className="font-medium text-gray-800 text-sm" data-id="element-289">
                    {b.text}
                  </span>
                </div>)}
            </div>
          </div>
        </div>
      </Section>
    </>;
};